// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"cbecd134","501":"45f4a3a8","646":"8ebc1466","778":"871e649f","964":"f5d114f8"}[chunkId] + ".chunk.js";
};